var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,{tag:"component",staticClass:"en-charts",attrs:{"stack":_vm.stack,"store":_vm.store},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }